import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60,
      retry: false,
      // Solution of the bug with Chrome, that sometimes thinks that it's offline, so all the queries are paused
      networkMode: 'always',
    },
  },
});

export default queryClient;
